import MathHelpers from "./MathHelpers";

export class CalculatedDamage {
  public Damage: number;
  public CriticalHit: boolean;

  constructor(damage: number, criticalHit: boolean) {
    this.Damage = damage;
    this.CriticalHit = criticalHit;
  }
}

export class DamageMath {
  /**
   * Calculates the arrow damage.
   * Formula:
   * Damage = (Strength + BowDamage) / PullOfBow
   *
   * @param strength - Base strength of the character.
   * @param bowDamage - Base damage of the bow.
   * @param pullOfBow - Normalized pull of the bow (0.01 - N).
   * @returns Calculated damage.
   */
  static calculateArrowDamage(
    strength: number,
    dexterity: number,
    bowDamage: number,
    pullOfBow: number
  ): CalculatedDamage {
    if (pullOfBow < 0.01) {
      pullOfBow = 0.01; // prevent division by zero or too tiny values
    }

    const damage = Math.trunc((strength + bowDamage) / pullOfBow);
    let criticalDamage = damage;
    const baseCriticalChance = 5;
    const totalCriticalChance = baseCriticalChance + dexterity;

    const randomNum = MathHelpers.RandomInteger(1, 100);
    const isCritical = randomNum < totalCriticalChance;

    if(isCritical) {
      criticalDamage = Math.trunc(criticalDamage * 1.2);
    }

    return new CalculatedDamage(criticalDamage, isCritical);
  }

  static calculateMonsterDamage(baseMonsterDamage: number, vitality: number) {
    return Math.max(1, baseMonsterDamage - vitality);
  }

  static calculateDamageToCharacter(damage: number, vitality: number) {
    let reduction = vitality;
    return Math.max(damage - reduction, 1);
  }
}
